import React from "react";

import { wrap } from "./RydTestbedWrap";
import { RydAudioInputSelector } from "../components/widgets/data-input/RydAudioInputSelector";

export function AudioInputSelectorTestbed() {
    const [selectedDeviceId, setSelectedDeviceId] = React.useState<string>('');
    return wrap(<>
        {/* Add your testbed components here */}
        <h1>AudioInputSelector Testbed</h1>
        Selected: {selectedDeviceId}
        <RydAudioInputSelector selectedDeviceId={selectedDeviceId} setSelectedDeviceId={setSelectedDeviceId} />
    </>);
}